module.exports = __webpack_public_path__ + "img/logo-cws.38ddd15f.svg";